<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table id="ni-ri-equip-ins-table">
      <thead>
        <tr>
          <th>Line No.</th>
          <th
            v-for="columnData in regulatoryInfoEquipmentInsFields.columns"
            :key="columnData.id"
            :class="columnData.className"
            :title="columnData.title"
          >
            <label>{{ columnData.label }}</label>
          </th>
        </tr>
      </thead>
      <tbody class="ni-app-ri-equip-ins-tbody">
        <tr
          v-for="(row, index) in rows"
          :key="row.id"
          :class="[
            row.itemStatus === 'Rework – Additional Data Required'
              ? 'rework-item'
              : ''
          ]"
          @click="onRowClick($event)"
          @change="!isLoading ? changeOnRow($event, index, row) : ''"
        >
          <ValidationObserver>
            <td class="line-number">{{ row.lineNumber }}</td>
            <td class="line-errors">{{ row.lineErrors }}</td>
            <td class="supp-item-nbr">
              <b-input
                class="suppItemNbr"
                v-model="row.suppItemNbr"
                disabled
              ></b-input>
            </td>
            <td>
              <b-input
                class="englishPrdctNoun"
                disabled
                :value="row.englishPrdctNoun"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemGiErrTbs,
                    'englishPrdctNoun',
                    row.englishPrdctNoun
                  )
                "
              ></b-input>
            </td>
            <td>
              <b-input
                class="itemStatus"
                v-model="row.itemStatus"
                disabled
                :title="row.itemStatus"
              ></b-input>
            </td>
            <td class="hidden">
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="productCategory"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="productCategory"
                    v-model="row.productCategory"
                  >
                    <option value="Equipment and Instruments"
                      >Equipment and Instruments</option
                    >
                    <option value="Biologicals">Biologicals</option>
                    <option value="Chemicals and Biochemical Reagents"
                      >Chemicals and Biochemical Reagents</option
                    >
                    <option value="Consumables">Consumables</option>
                    <option value="Diagnostics">Diagnostics</option>
                    <option value="Furniture">Furniture</option>
                    <option value="Training and Services"
                      >Training and Services</option
                    >
                    <option value="Safety Products">Safety Products</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-model="row.powerSupplyType"
                :value="
                  row.powerSupplyType === undefined
                    ? (row.powerSupplyType = ' ')
                    : row.powerSupplyType
                "
                class="powerSupplyType"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'powerSupplyType',
                    row.powerSupplyType
                  )
                "
                :disabled="row.productCategory !== 'Equipment and Instruments'"
              >
                <option value=" "></option>
                <option value="Battery">Battery</option
                ><option value="Cord">Cord</option
                ><option value="Power Cord">Power Cord</option
                ><option value="Rechargeable Battery"
                  >Rechargeable Battery</option
                ></b-select
              >
            </td>
            <td>
              <b-select
                class="euWeeCategory"
                v-model="row.euWeeCategory"
                :value="
                  row.euWeeCategory === undefined
                    ? (row.euWeeCategory = ' ')
                    : row.euWeeCategory
                "
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'euWeeCategory',
                    row.euWeeCategory
                  )
                "
                :disabled="
                  row.productCategory !== 'Equipment and Instruments' &&
                    row.productCategory !== 'Furniture'
                "
              >
                <option value=" "></option>
                <option value="W3E1">W3E1</option>
                <option value="W3E2">W3E2</option>
                <option value="W3E3">W3E3</option>
                <option value="W3E4">W3E4</option>
                <option value="W3E5">W3E5</option>
                <option value="W3E6">W3E6</option>
              </b-select>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'ukWeeCategory'">
              <v-select
                :filterable="false"
                :taggable="false"
                :options="ukWeeCategoryOptions"
                class="ukWeeCategory"
                v-bind:class="
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'ukWeeCategory',
                    row.ukWeeCategory
                  )
                "
                :disabled="
                  row.productCategory !== 'Equipment and Instruments' &&
                    row.productCategory !== 'Furniture'
                "
                v-model="row.ukWeeCategory"
                @search="fetchTypeAhead"
                @input="changeOnRow($event, index, row)"
                :title="row.ukWeeCategory"
              >
                <template slot="option" slot-scope="ukWeeCategoryOption">
                  <div class="d-center">
                    {{ ukWeeCategoryOption.label }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="ukWeeCategoryOption"
                  title="ukWeeCategoryOption"
                >
                  <div class="selected d-center">
                    {{ ukWeeCategoryOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td>
              <b-select
                v-model="row.batteryIncluded"
                :value="
                  row.batteryIncluded === undefined
                    ? (row.batteryIncluded = ' ')
                    : row.batteryIncluded
                "
                class="batteryIncluded"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'batteryIncluded',
                    row.batteryIncluded
                  )
                "
                :disabled="row.productCategory !== 'Equipment and Instruments'"
              >
                <option value=" "></option>
                <option value="Y">Yes</option
                ><option value="N">No</option></b-select
              >
            </td>
            <td>
              <b-input
                class="batteryWt"
                @change.native="row.batteryWt = $event.target.value"
                :value="row.batteryWt"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'batteryWt',
                    row.batteryWt
                  ),
                  row.batteryIncluded === 'Y' && !row.batteryWt
                    ? 'is-danger'
                    : ''
                ]"
                :disabled="row.productCategory !== 'Equipment and Instruments'"
              ></b-input>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'batteryType'">
              <v-select
                :filterable="false"
                :taggable="false"
                :options="batteryTypeOptions"
                class="batteryType"
                v-bind:class="[
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'batteryType',
                    row.batteryType
                  ),
                  row.nbrOfBatteries && !row.batteryType ? 'is-danger' : '',
                  row.batteryIncluded === 'Y' && !row.batteryType
                    ? 'is-danger'
                    : ''
                ]"
                :disabled="row.productCategory !== 'Equipment and Instruments'"
                v-model="row.batteryType"
                @search="fetchTypeAhead"
                @input="changeOnRow($event, index, row)"
                :title="row.batteryType"
              >
                <template slot="option" slot-scope="batteryTypeOption">
                  <div class="d-center">
                    {{ batteryTypeOption.label }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="batteryTypeOption"
                  title="batteryTypeOption"
                >
                  <div class="selected d-center">
                    {{ batteryTypeOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td>
              <b-input
                class="nbrOfBatteries"
                @change.native="row.nbrOfBatteries = $event.target.value"
                :value="row.nbrOfBatteries"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'nbrOfBatteries',
                    row.nbrOfBatteries
                  ),
                  row.batteryType && !row.nbrOfBatteries ? 'is-danger' : '',
                  row.batteryIncluded === 'Y' && !row.nbrOfBatteries
                    ? 'is-danger'
                    : ''
                ]"
                :disabled="row.productCategory !== 'Equipment and Instruments'"
              ></b-input>
            </td>
            <td>
              <b-select
                class="lithiumBattery"
                v-model="row.lithiumBattery"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'lithiumBattery',
                    row.lithiumBattery
                  ),
                  row.batteryIncluded === 'Y' && !row.lithiumBattery
                    ? 'is-danger'
                    : ''
                ]"
                :disabled="row.productCategory !== 'Equipment and Instruments'"
              >
                <option value=" "></option>
                <option value="10"
                  >10 - Packed Separately Alongside Appliance</option
                >
                <option value="20"
                  >20 - Contained Within Appliance When Shipped</option
                >
              </b-select>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:productCategory,Equipment and Instruments,Furniture"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    class="nbrOfBulbs"
                    @change.native="row.nbrOfBulbs = $event.target.value"
                    :value="row.nbrOfBulbs"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value > 100) this.value = 100; "
                    :class="[
                      !row.nbrOfBulbs > 0 && !row.nbrOfBulbs > 100
                        ? 'invalid'
                        : '',
                      isApiErrorField(
                        row.psfsEuNewItemRiEqErrTbs,
                        'nbrOfBulbs',
                        row.nbrOfBulbs
                      )
                    ]"
                    :disabled="
                      row.productCategory !== 'Equipment and Instruments' &&
                        row.productCategory !== 'Furniture'
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                class="bulbType"
                v-model="row.bulbType"
                :value="
                  row.bulbType === undefined
                    ? (row.bulbType = ' ')
                    : row.bulbType
                "
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemRiEqErrTbs,
                    'bulbType',
                    row.bulbType
                  ),
                  !row.bulbType &&
                  row.nbrOfBulbs !== undefined &&
                  row.nbrOfBulbs > 0
                    ? 'invalid'
                    : ''
                ]"
                :disabled="
                  row.productCategory !== 'Equipment and Instruments' &&
                    row.productCategory !== 'Furniture'
                "
              >
                <option value=" "></option>
                <option value="FLUO COMP">FLUO COMP</option>
                <option value="FLUO LINE">FLUO LINE</option>
                <option value="LED">LED</option>
                <option value="OTHER">OTHER</option>
              </b-select>
            </td>
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "RegulatoryInfoEquipmentInstrumentTab",
  components: { vSelect },
  data() {
    return {
      actions: [],
      isLoading: false,
      paginationParams: [],
      showSubmissionInReadOnly: false,
      regulatoryInfoEquipmentInsFields: {
        columns: [
          {
            className: "lineErrors",
            field: "lineErrors",
            label: "Line Errors",
            title: "Line Errors"
          },
          {
            className: "suppItemNbr",
            field: "suppItemNbr",
            label: "Supplier Item No.",
            title: "Supplier Item No.\nMax length is 25."
          },
          {
            className: "englishPrdctNoun",
            field: "englishPrdctNoun",
            label: "English Product Description",
            title: "Product Description"
          },
          {
            className: "itemStatus",
            field: "itemStatus",
            label: "Item Status",
            title: "Item Status"
          },
          {
            className: "powerSupplyType",
            field: "powerSupplyType",
            label: "Type of power supply",
            title: "Please select type of Power supply"
          },
          {
            className: "euWeeCategory",
            field: "euWeeCategory",
            label: "EU WEEE category",
            title: "Please select the WEEE category"
          },
          {
            className: "ukWeeCategory",
            field: "ukWeeCategory",
            label: "UK WEEE Category",
            title: "UK WEEE Category"
          },
          {
            className: "batteryIncluded",
            field: "batteryIncluded",
            label: "WEEE -Are batteries included in the unit?",
            title:
              " (all mains equipment) or Power Cord or back-up battery Y/N. If Y, complete BY,CE,CF"
          },
          {
            className: "batteryWt",
            field: "batteryWt",
            label: "WEEE - Weight of battery(grams for weight)",
            title: "Weight of the actual battery(grams for weight)"
          },
          {
            className: "batteryType",
            field: "batteryType",
            label: "WEEE- battery type",
            title: "Actual battery type"
          },
          {
            className: "nbrOfBatteries",
            field: "nbrOfBatteries",
            label: "WEEE -Number of Batteries",
            title: "Enter the number of batteries (numeric value only)"
          },
          {
            className: "lithiumBattery",
            field: "lithiumBattery",
            label: "WEEE - Lithium battery specification",
            title:
              "If lithium batteries are used please confirmed they are packed separatly or within appliance when shipped"
          },
          {
            className: "nbrOfBulbs",
            field: "nbrOfBulbs",
            label: "Number of Bulbs",
            title: "Enter number of bulbs, value should be between 0 and 100"
          },
          {
            className: "bulbType",
            field: "bulbType",
            label: "Bulb Type",
            title: "Indicate bulb type"
          }
        ]
      },
      rowIds: [],
      rows: [],
      batteryTypeOptions: [],
      ukWeeCategoryOptions: []
    };
  },
  props: ["riEiTabSubmissionID", "loadRiEiTabData"],
  watch: {
    loadRiEiTabData(value) {
      if (value.loadDetails) {
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        this.loadTabItemDetails();
      }
    }
  },
  mounted() {},
  methods: {
    changeOnRow(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("riEiEuRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("riEiEuRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsEuNewItemRiEqErrTbs" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              this.updateRiEiItem(rowData, index);
              break;
            }
          }
        }
      }
    },
    fetchTypeAhead(search, loading) {
      if (search.length > 0) {
        var scope = this;

        loading(true);
        scope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}eu/loadTypeaheadsCodes?fieldName=${scope.typeAheadTriggered}&code=${search}`
          )
          .then(function(response) {
            loading(false);
            switch (scope.typeAheadTriggered) {
              case "batteryType":
                scope.batteryTypeOptions = response.data;
                break;
              case "ukWeeCategory":
                scope.ukWeeCategoryOptions = response.data;
                break;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load matching results. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    isApiErrorField(errorFieldNames, className, value) {
      if (errorFieldNames && errorFieldNames.length > 0) {
        for (var i = 0; i < errorFieldNames.length; i++) {
          if (
            errorFieldNames[i].columnName
              .split(" ")[0]
              .replace(/_/g, "")
              .toLowerCase() === className.toLowerCase()
          ) {
            if (className.toLowerCase() === "batterytype") {
              return "danger";
            } else {
              return "api-error";
            }
          }
        }
      }
    },
    onRowClick(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    loadTabItemDetails() {
      var scope = this;
      scope.isLoading = true;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (
        this.actions.fErrors ||
        this.actions.fSuppItemNbr ||
        this.actions.fProductNoun ||
        this.actions.fReworkItem
      ) {
        requestPayload.actions.push("Filter");
        requestPayload.filterMap = {};
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fSuppItemNbr) {
          requestPayload.filterMap.suppItemNbr = this.actions.fSuppItemNbr;
        }
        if (this.actions.fProductNoun) {
          requestPayload.filterMap.englishPrdctNoun = this.actions.fProductNoun;
        }
        if (this.actions.fReworkItem) {
          requestPayload.filterMap.itemStatus = "K";
        }
      }
      if (this.actions.sortSuppItemNbr) {
        requestPayload.actions.push("Sort");
        requestPayload.sortMap = {};
        requestPayload.sortMap.suppItemNbr = this.actions.sortSuppItemNbr;
      }
      if (this.actions.srFieldName && this.actions.srFieldValue) {
        requestPayload.actions.push("Search");
        requestPayload.searchMap = {};
        requestPayload.searchMap[
          this.actions.srFieldName
        ] = this.actions.srFieldValue;
      }

      scope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/getRiEquipmentInfo?nbrNewItemCrKey=${scope.riEiTabSubmissionID}&pageIndex=${scope.paginationParams.pageIndex}&noOfRecords=${scope.paginationParams.numberOfItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          var riEiPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          };
          scope.$emit("riEiPaginationParams", riEiPaginationParams);
          scope.$emit("rieiCount", {
            totalErrorCount: response.data.errorCount,
            tabErrorCount: response.data.riEquipTabErrorCount
          });

          //check supplier validate value
          if (sessionStorage.getItem("se_ni_user_eu")) {
            if (response.data.validateForm === "Y") {
              scope.$emit("disableSupplierValidateFromTab", true);
            } else {
              scope.$emit("enableSupplierValidateFromTab", true);
            }
          }

          scope.isLoading = false;
          scope.rows = [];
          scope.rowIds = [];
          var mutableResponseRows = response.data.psfsEuNewItemRiEquipTbs;
          if (requestPayload.actions.length > 0) {
            if (response.data.psfsEuNewItemRiEquipTbs.length > 0) {
              for (
                var i = 0, lineNumber = riEiPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                scope.rowIds.push(mutableResponseRows[i].genlInfoId);
                mutableResponseRows[i].lineNumber = lineNumber;
              }
              scope.rows = mutableResponseRows;
              sessionStorage.setItem(
                "riEiEuRows",
                JSON.stringify(response.data.psfsEuNewItemRiEquipTbs)
              );
            } else {
              scope.rows = [];
              scope.rowIds = [];
            }
          } else {
            if (response.data.psfsEuNewItemRiEquipTbs.length > 0) {
              for (
                var j = 0, lineNumberJ = riEiPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                scope.rowIds.push(mutableResponseRows[j].genlInfoId);
                mutableResponseRows[j].lineNumber = lineNumberJ;
              }
              scope.rows = mutableResponseRows;
              sessionStorage.setItem(
                "riEiEuRows",
                JSON.stringify(response.data.psfsEuNewItemRiEquipTbs)
              );
            } else {
              scope.rows = [];
              scope.rowIds = [];
              sessionStorage.removeItem("rows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${scope.riEiTabSubmissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        });
    },
    updateRiEiItem(requestPayload, index) {
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      if (sessionStorage.getItem("se_ni_user_eu")) {
        requestPayload.createdBy = JSON.parse(
          sessionStorage.getItem("se_ni_user_eu")
        ).networkId;
      } else {
        requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
      }

      var updatedRowData = {};

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      scope.isLoading = true;
      scope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/updateRiEquipmentInfo?nbrNewItemCrKey=${scope.riEiTabSubmissionID}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber = scope.rows[index].lineNumber;
          scope.rows[index] = apiRow;
          var riEiEuRows = JSON.parse(sessionStorage.getItem("riEiEuRows"));
          riEiEuRows.splice(index, 1, response.data);
          sessionStorage.setItem("riEiEuRows", JSON.stringify(riEiEuRows));
          scope.$emit("rieiCount", {
            totalErrorCount: response.data.errorCount,
            tabErrorCount: response.data.riEquipTabErrorCount
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${scope.riEiTabSubmissionID}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".ni-app-ri-equip-ins-tbody")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".ni-app-ri-equip-ins-tbody")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    }
  }
};
</script>
